/* Onboarding step → badge tone, shared by the admin list/detail. */
export const STEP_TONE = {
  pending_email: 'neutral',
  pending_terms: 'neutral',
  pending_plan: 'info',
  pending_payment: 'info',
  pending_documents: 'warning',
  pending_validation: 'warning',
  validation_rejected: 'danger',
  active: 'success',
}
